import PAImage from "component/design-system/images/PAImage";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import Text from "component/design-system/typography/Text";
import styles from "modules/home/home.module.scss";
import LazyBackgroundImage from "modules/lazy-background-image/LazyBackgroundImage";
import { useTranslation } from "next-i18next";
import Image from "next/legacy/image";
import Link from "next/link";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import localStyles from "./about-pa.module.scss";

interface IProps {
  AboutPAContent: {
    content_1: {
      content: string,
      H3: string
    },
    content_2: {
      content: string,
      H3: string
    }
  }
}

function AboutPA(props: IProps) {
  const { AboutPAContent } = props;
  const { content_1, content_2 } = AboutPAContent || {};
  const { t } = useTranslation("home");
  const aboutSrc = getRelativeImagePath("/images/home/about-sprite.webp");
  const aboutPAAltText = t("Proudly Made in Canada");
  const rightToRepairAltText = t("Advancing Automotive Repair Access");

  return (
    <div className="d-flex flex-column align-items-center">
      <div className={localStyles.about_pa_container}>
        <div className={`${localStyles.text_container} ${styles.homeContainer}`}>
          <Text size={2} className="text-center">{t("what_is_pa")}</Text>
          <Link href="/about-us" title={t("Know about our story and our mission")}>
            <PAText
              component="p"
              fontSize={FONT_SIZE[2]}
              className={`text-center p-t-10 m-t-10 ${localStyles.read_more_link}`}
              color="black"
            >
              {t("story")}
            </PAText>
          </Link>

          <div className={localStyles.perk_points}>
            <div className={`d-flex flex-column ${localStyles.each_item}`}>
              <div className="d-flex">
                <PAImage
                  src={getRelativeImagePath("/images/public/canadian-about-PA.webp")}
                  alt={aboutPAAltText}
                  title={aboutPAAltText}
                  width={50}
                  height={50}
                />
                <PAText component="h3">{content_1?.H3 || t("heading1")}</PAText>
              </div>
              <PAText
                component="p"
                className={`${localStyles.each_subtext} m-t-10`}
                fontSize={FONT_SIZE[2]}
              >
                {content_1?.content || t("content1")}
              </PAText>
            </div>

            <div className={`d-flex flex-column ${localStyles.each_item}`}>
              <div className="d-flex">
                <Image
                  src={getRelativeImagePath("/images/public/rightToRepair-about-PA.webp")}
                  alt={rightToRepairAltText}
                  title={rightToRepairAltText}
                  width={50}
                  height={50}
                  unoptimized
                />
                <PAText component="h3">{content_2?.H3 || t("heading2")}</PAText>
              </div>

              <PAText
                component="p"
                className={`${localStyles.each_subtext} m-t-10`}
                fontSize={FONT_SIZE[2]}
              >
                {content_2?.content || t("content2")}
              </PAText>
            </div>
          </div>
        </div>

        <LazyBackgroundImage
          src={aboutSrc}
          className={`${localStyles.bottom_left} ${localStyles.car_partsavatar}`}
        />

        <LazyBackgroundImage
          src={aboutSrc}
          className={`${localStyles.bottom_right} ${localStyles.wheel_partsavatar}`}
        />

        <LazyBackgroundImage
          src={aboutSrc}
          className={`${localStyles.bottom_right_second} ${localStyles.wrench_partsavatar}`}
        />

        <LazyBackgroundImage
          src={aboutSrc}
          className={`${localStyles.top_right} ${localStyles.gear_partsavatar}`}
        />
      </div>
    </div>
  );
}
export default AboutPA;
